import {
  Bell,
  CalendarDays,
  Home,
  ReceiptEuro,
  UserCog,
  UserRound,
  type LucideIcon,
} from 'lucide-react';
import { ROUTES } from 'constants/routes';

export interface NavRoute {
  href?: string;
  label: string;
  icon: LucideIcon;
}

export const HOME_NAV_ROUTE: NavRoute = {
  href: ROUTES.HOME,
  label: 'start',
  icon: Home,
};

export const NOTIFICATIONS_NAV_ROUTE: NavRoute = {
  href: ROUTES.NOTIFICATIONS,
  label: 'insuranceNotifications',
  icon: Bell,
};

export const MANAGER_NAV_ROUTES: NavRoute[] = [
  {
    href: ROUTES.APPOINTMENTS,
    label: 'insuranceAppointments',
    icon: CalendarDays,
  },
  { href: ROUTES.PATIENTS, label: 'insurancePatients', icon: UserRound },
];

export const BILLING_NAV_ROUTES: NavRoute[] = [
  { href: ROUTES.BILLING, label: 'insuranceBilling', icon: ReceiptEuro },
];

export const ADMIN_NAV_ROUTES: NavRoute[] = [
  HOME_NAV_ROUTE,
  ...MANAGER_NAV_ROUTES,
  ...BILLING_NAV_ROUTES,
  {
    href: ROUTES.ADMINISTRATORS,
    label: 'insuranceAdministrators',
    icon: UserCog,
  },
  NOTIFICATIONS_NAV_ROUTE,
];
